import React, { Fragment } from 'react';
import { useWidget, useModel, ModelProvider } from '../core/hooks';
import ErrorBounds from './error-bounds';

interface AddonProps {
  id: string;
  children: React.ReactNode;
  hostRef: React.RefObject<HTMLDivElement>;
}

interface AddonsProps {
  addons?: string[];
  hostRef: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
}
export function Addon({ id, children, hostRef }: AddonProps) {
  const model = useModel(id);
  const Widget = useWidget(model && (model.type as string));

  if (!model || !model.type || !Widget) return <Fragment>{children}</Fragment>;

  return (
    <ModelProvider value={model}>
      <Widget {...model.content} className={'__a ' + model.cl} id={model.key} hostRef={hostRef}>
        {children}
      </Widget>
    </ModelProvider>
  );
}

export function Addons({ addons, hostRef, children }: AddonsProps) {
  if (!addons || !addons.length) return <Fragment>{children}</Fragment>;

  return (
    <Addon id={addons[0]} hostRef={hostRef}>
      <Addons addons={addons.slice(1)} hostRef={hostRef}>
        {children}
      </Addons>
    </Addon>
  );
}
